export default __webpack_public_path__ + "static/media/about-grid-04.7a65f4e3.jpg";